'use client';
import styled from 'styled-components';

export const Document = styled.div`
  position: relative;
`;

export const HeroBackground = styled.div`
  position: absolute;
  height: 0;
  top: 0;
  left: 0;
  width: 100%;
  background: linear-gradient(
    180deg,
    ${({ theme }) => theme.palette.grey1100} 0%,
    rgba(47, 49, 55, 0.7) 100%
  );

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
  height: 152px;
`;

export const Body = styled.div`
  position: relative;
  padding-top: 40px;
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    padding-top: 0;
  }
`;
